import { render } from "./PlayoutFilesLiveSourcesTab.vue?vue&type=template&id=13578f1e"
import script from "./PlayoutFilesLiveSourcesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutFilesLiveSourcesTab.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayoutV2/PlayoutFilesLiveSourcesTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "13578f1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('13578f1e', __exports__)) {
    api.reload('13578f1e', __exports__)
  }
  
  module.hot.accept("./PlayoutFilesLiveSourcesTab.vue?vue&type=template&id=13578f1e", () => {
    api.rerender('13578f1e', render)
  })

}


export default __exports__